/**
 * VERSIONE LIBRERIA 3
 */
/**
 * autocomplete
 * extra config param
 * config.model : nome modello
 * config.description : vettore campi da visualizzare nella description
 * config.description_separator : separatore dei campi description default -
 *
 **/
var RenderAutocomplete = Render.extend({
    url : null,
    type : 'autocomplete',
    classData : 'autocomplete',
    classTemplate : 'autocomplete',
    autocomplete_view_selector : '[data-render_autocomplete_view]',
    autocomplete_input_selector : '[data-render_autocomplete_input]',
    model_description : [],
    separator : null,
    fields : [],
    autocompleteModel : null,
    n_items : null,
    metodo : null,
    modelData : null,

    _getLabelValue : function (modelData) {
        var self = this;
        var label = $.translate('general-ricerca');
        if (!modelData)
            return label;
        if (!self.model_description) {
            if (modelData.label)
                return modelData.label;
            return label;
        }
        //console.log("get label valueeeeeee",modelData,self.model_description)
        label = '';
        var separator = self.separator?self.separator:' ';
        for (var f in self.model_description) {
            if (!modelData[ self.model_description[f] ])
                continue;
            label += modelData[ self.model_description[f] ];
            if (f < self.model_description.length -1 )
                label += separator;
        }
        return label;
    },
    /**
     * ritorna il nome dell'inputview, tiene conto del fatto che si potrebbe trovare in un hasmany
     * e il nome potrebbe avere le []
     */

    _getInputViewName : function () {
        var self = this;
        var v_name = self.key;
        if (v_name.indexOf('[]') >= 0) {
            v_name = v_name.substr(0,v_name.length-2);
            return v_name+"_view[]";
        }
        return v_name+ "_view";
    },

    _getFieldValue : function(modelData) {
        var self = this;
        if (!modelData || modelData.length === 0 || !self.fields || self.fields.length === 0)
            return '';
        return modelData[ self.fields[0] ];
    },
    _renderEdit : function (jQe) {
        var self = this;
        // nel caso di custom devo normalizzare i risultati
        // TODO va fatto nel costruttore in modo che valga per tutti
        var el = jQe.find(self.control_selector);
        el.attr("name", self.key).attr("value", self.value);
        var el = jQe.find(self.autocomplete_input_selector);
        var v_name = self._getInputViewName();
        el.attr("name", v_name).val(self._getFieldValue(self.modelData)).attr('value',self._getFieldValue(self.modelData));

        //el.attr("name", self.key + "_view").val(self._getFieldValue(self.modelData)).attr('value',self._getFieldValue(self.modelData));

        var el = jQe.find(self.autocomplete_view_selector);
        el.attr("data-render_autocomplete_view", v_name).html(self._getLabelValue(self.modelData));

        //el.attr("id", "div_" + self.key + "_view").html(self._getLabelValue(self.modelData));
        return ;
    },

    _renderSearch : function (jQe) {
        var self = this;
        self._renderEdit(jQe);
        var el = jQe.find(self.control_selector);
        el.attr("name", 's_' + self.key + '[]');
        $('<input>').attr({
            type: 'hidden',
            name: 's_' + self.key + "_operator",
            'data-control_operator' : self.key,
            value : self.operator
        }).appendTo(jQe);
    },
    _finalizeSearch : function () {
        this._finalizeEdit();
    },
    _createUrl : function () {
        var self = this;
        var url = self.url?self.url:"/api/json/autocomplete/" + self.autocompleteModel + "?";

        if (self.fields) {
            for(var f in self.fields) {
                url+="field[]="+self.fields[f]+"&";
            }
        }
        /* @TODO se metto la description diventa difficile cambiare la
         if (self.model_description) {
         for(var f in self.model_description) {
         url+="description[]="+self.model_description[f]+"&";
         }
         }
         */
        url += self.separator ? '&separator=' + self.separator : '';
        url += self.n_items ? '&n_items=' + self.n_items : '';
        url += self.metodo ? '&method=' + self.metodo : '';
        return url;
    },
    _finalizeEdit : function () {


        var self = this;
        var field = $(self.container).find(self.autocomplete_input_selector);
        var url = self._createUrl();

        var dataResult = new Bloodhound({
            datumTokenizer: function (datum) {

                return Bloodhound.tokenizers.whitespace(datum.label);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {

                //url: 'http://api.themoviedb.org/3/search/movie?query=%QUERY&api_key=470fd2ec8853e25d2f8d86f685d2270e',
                url: url + "&term=%QUERY",
                filter: function (json) {
                    //log.info("autocomplete data",json);
                    // Map the remote source JSON array to a JavaScript array
                    return $.map(json.result, function (element) {
                        return self.getAutocompleteRow(element);
                    });
                }


            }
        });

        dataResult.initialize();
        // Instantiate the Typeahead UI
        field.typeahead(null, {
            displayKey: 'label',
            source: dataResult.ttAdapter()
        });
        self._renderSelectedValue();
        $(self.container).find('[data-button_clear]').click(function () {
            field.typeahead('val','');
            $(self.container).find(self.control_selector).val('');
        })
    },
    _renderSelectedValue : function () {
        var self = this;
        var field = $(self.container).find('[data-render_element]');
        field.on('typeahead:selected', function (e, datum) {
            var fname = self.key;
            if (self.mode=='search')
                fname = 's_' + self.key +  '[]';
            var fieldNext = $(self.container).find('input[name="' + fname + '"]');
            var v_name = self._getInputViewName();
            var viewDiv = $(self.container).find('[data-render_autocomplete_view="' + v_name + '"]');
            datum.id ? fieldNext.val(datum.id) : fieldNext.val('');

            viewDiv.text(self._getLabelValue(datum.data));
            self.ev_selected(datum);
        });

    },
    getAutocompleteRow : function (element) {
        return element;


        return {
            label: element.label,
            value: element.id
        };
    },
    ev_selected : function (datum) {

    },
    getValue : function () {
        throw "not yet implemented";
    }
});